export default __webpack_public_path__ + "static/media/GreenTickSquare.bd039e79.svg";